'use client';

import { FC, ForwardedRef, forwardRef } from 'react';
import { CircularProgress, Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { defaultButtonStyles } from './button.styles';
import { clsx } from '../../utils/clsx';

export type ButtonColors = {
	fontColor?: string;
	hoverFontColor?: string;
	activeFontColor?: string;
	backgroundColor?: string;
	hoverBackgroundColor?: string;
	activeBackgroundColor?: string;
};

export interface ButtonLoadingCircleProps {
	loadingSpinnerSize?: number;
	strictColor?: boolean;
	transparent?: boolean;
	icon?: JSX.Element;
	colors?: ButtonColors;
}

export const ButtonLoadingCircle: FC<ButtonLoadingCircleProps> = ({ loadingSpinnerSize }) => (
	<CircularProgress size={loadingSpinnerSize ?? 14} sx={{ color: 'inherit' }} />
);

export interface ButtonProps extends Omit<MuiButtonProps, 'variant'>, ButtonLoadingCircleProps {
	loading?: boolean;
	variant?: 'primary' | 'secondary';
}

export const Button = forwardRef(
	(
		{ sx, children, loading, loadingSpinnerSize, variant, strictColor, colors, icon, transparent, ...props }: Omit<ButtonProps, 'ref'>,
		ref: ForwardedRef<HTMLButtonElement>
	) => (
		<MuiButton {...props} sx={clsx(defaultButtonStyles(variant, colors, strictColor, transparent), sx)} ref={ref}>
			{loading ? <ButtonLoadingCircle loadingSpinnerSize={loadingSpinnerSize} /> : icon}
			{children}
		</MuiButton>
	)
);

Button.displayName = 'Button';
